import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Offerings from "@/components/site/Offerings";
import Stats from "@/components/site/Stats";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import EventsSchedule from "@/components/site/EventsSchedule";
import Testimonials from "@/components/site/Testimonials";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import MobileSections from "@/components/site/MobileSections";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const t = setTimeout(() => scrollToId(id), 400);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <SmoothScroll>
      <div data-testid="home-page" className="bg-[#0B132B]">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <MobileSections
            groups={{
              highlights: (
                <>
                  <Offerings />
                  <Stats />
                </>
              ),
              story: (
                <>
                  <Manifesto />
                  <Gallery />
                </>
              ),
              events: <EventsSchedule />,
              reviews: <Testimonials />,
              visit: <ContactSection />,
            }}
          />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
